module.exports = __webpack_public_path__ + "6bde1b6f916b904d9d72c7978295ad48.png";